<div class="channels-search">
  <div class="channels-search__field">
    <mat-icon class="channels-search__search-icon" svgIcon="search"></mat-icon>
    <input
      class="channels-search__input"
      type="text"
      [(ngModel)]="text"
      (ngModelChange)="onSearchText($event)"
      (input)="onSearchText(search.value)"
      placeholder="{{ 'NGX-MESSAGING.CHANNELS.searchConversation' | translate }}"
      #search />
  </div>
  <button
    type="button"
    class="channels-search__icon-btn"
    [class.channels-search__icon-btn--active]="showFilters()"
    (click)="setShowFilters()">
    <mat-icon svgIcon="filters"></mat-icon>
  </button>
  <button
    type="button"
    class="channels-search__icon-btn"
    *hasWorkspaceFeature="[WorkspaceFeatures.canReadAllMessages]"
    [matMenuTriggerFor]="menuOptions">
    <mat-icon svgIcon="more_vert"></mat-icon>
  </button>
  <mat-menu #menuOptions>
    <button mat-menu-item (click)="readAllMessages()">
      {{ 'NGX-MESSAGING.readAllMessages' | translate }}
    </button>
  </mat-menu>
</div>
